import React from 'react'
import Navbar from '../components/Navbar'
import LandingPage from '../components/LandingPage'

function LLandingpage() {
  return (
    <div>
        <Navbar />
        <LandingPage />
    </div>
  )
}

export default LLandingpage